import {Entity} from "../../core/commons/entity";
import {CategoriaDictamen} from "./categoria-dictamen";
/**
 * Created by juan on 09/03/17.
 */
export class Dictamen implements Entity {

    id: number;
    name: string;
    category: CategoriaDictamen;
    createDate: Date;
    keywords: string[];

    constructor(value: Object = {}) {
        Object.assign(this, value);
        if (this.createDate)
            this.createDate = new Date(value['createDate'].year+"-"+value['createDate'].monthValue+"-"+value['createDate'].dayOfMonth);
        if (this.category)
            this.category = new CategoriaDictamen( this.category );

    }

    public getFileName() : string{
        return this.name.replace(/ /g,"-")+".pdf";
    }

}


// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/dictamen.ts